import { render, staticRenderFns } from "./OneRiskWaiver.vue?vue&type=template&id=173c8d8a&scoped=true"
import script from "./OneRiskWaiver.vue?vue&type=script&lang=ts"
export * from "./OneRiskWaiver.vue?vue&type=script&lang=ts"
import style0 from "./OneRiskWaiver.vue?vue&type=style&index=0&id=173c8d8a&prod&lang=scss"
import style1 from "./OneRiskWaiver.vue?vue&type=style&index=1&id=173c8d8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173c8d8a",
  null
  
)

export default component.exports